import { useLang } from "../i18n/LanguageContext";
import { Reveal, Eyebrow } from "./Reveal";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "./ui/accordion";

export default function Faq() {
  const { t } = useLang();
  const f = t.faq;

  return (
    <section id="faq" data-testid="faq-section" className="relative bg-brand-surface py-20 md:py-32">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20 lg:px-8">
        <Reveal>
          <Eyebrow>{f.eyebrow}</Eyebrow>
          <h2 className="mt-5 font-display text-4xl font-normal leading-tight tracking-tight text-brand-ink md:text-5xl">
            {f.heading}
          </h2>
          <p className="mt-5 text-base leading-relaxed text-brand-inksoft">{f.subtitle}</p>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full">
            {f.items.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-brand-border">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-5 text-left font-display text-lg text-brand-ink hover:no-underline"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-base leading-relaxed text-brand-inksoft">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
